"use client";

import { forwardRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { backgroundColorLevelCurrent } from "@churchofjesuschrist/eden-style-constants";
import { sharedCheckCss } from "../utils/sharedCss";
import { jsx as _jsx } from "react/jsx-runtime";
export const InternalUseOnlyRadio = styled.input.attrs({
  type: "radio"
}).withConfig({
  componentId: "sc-bv55qe-0"
})(["", ";border-radius:50%;&:checked{box-shadow:inset 0px 0px 0px 3px ", ";}"], sharedCheckCss, backgroundColorLevelCurrent);

/**
 * The Radio component is used when there are two or more options and the user must choose only one.
 */
const Radio = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InternalUseOnlyRadio, {
  ref: ref,
  ...props
}));
Radio.displayName = "Radio";
Radio.propTypes = {
  /** The checked state for controlled use. */
  checked: PropTypes.bool,
  /** Default checked state for uncontrolled use */
  defaultChecked: PropTypes.bool,
  /** Makes the input not mutable, focusable, or even submitted with the form */
  disabled: PropTypes.bool,
  /** Used to reference the input in JavaScript, or to reference form data after a form is submitted */
  name: PropTypes.string,
  /** Callback to execute when the Radio is toggled */
  onChange: PropTypes.func,
  /** Whether the input is required to be filled out to validate */
  required: PropTypes.bool,
  /** Value of the Radio */
  value: PropTypes.string
};
export default Radio;